import { ReactNode } from "react";

export interface EntityGridProps<T> {
  data: T[];
  isLoading: boolean;
  renderItem: (item: T) => ReactNode;
  emptyMessage?: string;
}

export const EntityGrid = <T extends { id: string }>({ 
  data, 
  isLoading, 
  renderItem,
  emptyMessage = "No items found matching your search criteria." 
}: EntityGridProps<T>) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="bg-white rounded-lg shadow-sm p-5 animate-pulse">
            <div className="flex justify-between items-center mb-3">
              <div className="h-5 bg-gray-200 rounded w-1/3"></div>
              <div className="h-8 w-8 bg-gray-200 rounded-full"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded mb-4"></div>
            <div className="space-y-3">
              <div className="h-3 bg-gray-200 rounded"></div>
              <div className="h-3 bg-gray-200 rounded"></div>
              <div className="h-3 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="text-center p-8 bg-white rounded-lg shadow-sm border border-gray-100">
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {data.map(item => renderItem(item))}
    </div>
  );
};
